import { isNil } from "lodash-es";
import React, { PureComponent } from "react";

import { getCancelTokenSource, HttpError, IHttpCancelTokenSource, IHttpRequestConfig } from "@/browser";

export interface IFetcherRenderProps<T = any> {
  payload?: T;
  error?: HttpError;

  updatePayload: (payload: T) => void;
  fetch: () => void;
}

export interface IFetcherProps {
  children: (listProps: IFetcherRenderProps) => React.ReactNode;
  fetchData: (_nothing: any, config: IHttpRequestConfig) => Promise<any>;
}

interface State extends IFetcherRenderProps {}

export class Fetcher extends PureComponent<IFetcherProps, State> {
  source: IHttpCancelTokenSource | null;

  constructor(props: IFetcherProps) {
    super(props);

    this.state = {
      updatePayload: this.handlePayloadUpdate,
      fetch: this.fetchData,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    if (!isNil(this.source)) {
      this.source.cancel();
    }
  }

  handlePayloadUpdate = (payload: IFetcherRenderProps["payload"]) => {
    this.setState({ payload });
  };

  fetchData = async () => {
    if (!isNil(this.source)) {
      this.source.cancel();
    }

    this.source = getCancelTokenSource();

    try {
      const payload = await this.props.fetchData({}, { cancelToken: this.source.token });
      this.setState({ payload, error: undefined });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    return this.props.children(this.state);
  }
}
